(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const formatMoney = (cents, format) => {
      const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
      const settings = {
        amount: [2, '.', ','],
        amount_no_decimals: [0, '.', ','],
        amount_with_comma_separator: [2, ',', '.'],
        amount_no_decimals_with_comma_separator: [0, ',', '.']
      }[placeholder] || [2, '.', ','];
      const number = (Number(cents) / 100).toFixed(settings[0]);
      const parts = number.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, settings[2]);
      return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join(settings[0] ? settings[1] : ''));
    };

    const initCart = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-cart-form]');
      if (!form) return;
      const status = root.querySelector('[data-cart-status]');
      const error = root.querySelector('[data-cart-error]');
      const timers = new WeakMap();

      const showError = (message) => {
        error.textContent = message || 'No se pudo actualizar el carrito. Inténtalo nuevamente.';
        error.hidden = false;
        error.focus();
      };

      const clearError = () => {
        error.hidden = true;
        error.textContent = '';
      };

      const setButtonLimits = (item) => {
        const input = item.querySelector('[data-quantity-input]');
        const minus = item.querySelector('[data-quantity-minus]');
        const plus = item.querySelector('[data-quantity-plus]');
        const value = Number(input.value);
        const step = Number(input.step || 1);
        minus.disabled = value - step < Number(input.min || 1);
        plus.disabled = input.max !== '' && value + step > Number(input.max);
      };

      const updateQuantity = async (item, requestedQuantity) => {
        const input = item.querySelector('[data-quantity-input]');
        const confirmedQuantity = Number(input.dataset.currentQuantity);
        const min = Number(input.min || 1);
        const step = Number(input.step || 1);
        const max = input.max === '' ? Infinity : Number(input.max);
        const requested = Number.parseInt(requestedQuantity, 10);
        const aligned = min + Math.round(((Number.isFinite(requested) ? requested : min) - min) / step) * step;
        const quantity = Math.min(max, Math.max(min, aligned));
        input.value = quantity;
        setButtonLimits(item);
        clearError();
        item.classList.add('is-loading');
        item.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(root.dataset.cartChangeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: item.dataset.lineKey, quantity })
          });
          const cart = await response.json();
          if (!response.ok) throw new Error(cart.description || cart.message);

          const updatedItem = cart.items.find((cartItem) => cartItem.key === item.dataset.lineKey);
          if (!updatedItem) {
            window.location.reload();
            return;
          }

          input.value = updatedItem.quantity;
          input.dataset.currentQuantity = updatedItem.quantity;
          item.querySelector('[data-line-total]').textContent = formatMoney(updatedItem.final_line_price, root.dataset.moneyFormat);
          root.querySelector('[data-cart-subtotal]').textContent = formatMoney(cart.total_price, root.dataset.moneyFormat);
          const count = root.querySelector('[data-cart-count]');
          if (count) count.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'producto' : 'productos'}`;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          status.textContent = `Cantidad actualizada a ${updatedItem.quantity}.`;
          setButtonLimits(item);
        } catch (requestError) {
          input.value = confirmedQuantity;
          setButtonLimits(item);
          showError(requestError.message);
        } finally {
          item.classList.remove('is-loading');
          item.removeAttribute('aria-busy');
        }
      };

      root.querySelectorAll('[data-cart-item]').forEach((item) => {
        const input = item.querySelector('[data-quantity-input]');
        setButtonLimits(item);

        item.querySelector('[data-quantity-minus]').addEventListener('click', () => {
          window.clearTimeout(timers.get(item));
          updateQuantity(item, Number(input.value) - Number(input.step || 1));
        });
        item.querySelector('[data-quantity-plus]').addEventListener('click', () => {
          window.clearTimeout(timers.get(item));
          updateQuantity(item, Number(input.value) + Number(input.step || 1));
        });
        input.addEventListener('change', () => {
          window.clearTimeout(timers.get(item));
          updateQuantity(item, input.value);
        });
        input.addEventListener('input', () => {
          window.clearTimeout(timers.get(item));
          timers.set(item, window.setTimeout(() => updateQuantity(item, input.value), 600));
        });
      });
    };

    document.querySelectorAll('[data-hp-cart]').forEach(initCart);
    document.addEventListener('shopify:section:load', (event) => initCart(event.target.querySelector('[data-hp-cart]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-quality-tabs]').forEach(function (root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-tab-button]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));
    if (!buttons.length || buttons.length !== panels.length) return;

    function activate(index, focusButton) {
      buttons.forEach(function (btn, i) {
        var selected = i === index;
        btn.setAttribute('aria-selected', String(selected));
        btn.tabIndex = selected ? 0 : -1;
        btn.classList.toggle('is-active', selected);
      });
      panels.forEach(function (panel, i) {
        var selected = i === index;
        panel.classList.toggle('is-active', selected);
        panel.hidden = !selected;
      });
      if (focusButton) buttons[index].focus();
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        activate(index, false);
      });

      button.addEventListener('keydown', function (event) {
        var newIndex = null;
        if (event.key === 'ArrowRight') newIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') newIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') newIndex = 0;
        if (event.key === 'End') newIndex = buttons.length - 1;
        if (newIndex !== null) {
          event.preventDefault();
          activate(newIndex, true);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
